import ConfigProvider from '../config-provider';
import Toast from './toast.service';
export default ConfigProvider.config(Toast, {
  componentName: 'Toast'
});